// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071706/js/" + chunkId + "." + {"44":"ea2d972f","225":"afa323f8","481":"3d61748e","486":"bb070b9d","770":"27abdabd"}[chunkId] + ".0.0017504970084948335.chunk.js";
};